var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.061 23.939a1.503 1.503 0 01-2.125 2.125L16 18.125 8.06 26.061a1.503 1.503 0 11-2.125-2.125L13.875 16 5.939 8.061a1.503 1.503 0 112.125-2.125L16 13.876l7.939-7.94a1.503 1.503 0 012.125 2.124L18.124 16l7.937 7.939z"
  })));
}
export default SvgXBold;